export enum PLAN_STATUS {
  ACTIVE = "active",
  PAUSED = "paused",
  EXPIRED = "expired",
  TRIALING = "trialing",
  CANCELED = "canceled",
  NOT_FOUND = "not_found",
  PAST_DUE = "past_due",
}

export const PLAN_REF_ID_MAPPING_V1 = {
  select: "AFTERSHOOT_SELECTS",
  edit: "AFTERSHOOT_EDITS",
  essential: "AFTERSHOOT_BUNDLE",
  pro: "AFTERSHOOT_PRO",
  pro_trial: "AFTERSHOOT_PRO_TRIAL",
  max: "AFTERSHOOT_MAX",
} as const;

export const PLAN_REF_ID_MAPPING = {
  culling: "AFTERSHOOT_CULLING",
  editing: "AFTERSHOOT_EDITING",
  retouching: "AFTERSHOOT_RETOUCHING",
  all: "AFTERSHOOT_ALL_APP",
} as const;

export const ADDON_REF_ID_MAPPING = {
  profiles: "PROFILES",
  gallery_unlimited: "GALLERY_UNLIMITED",
} as const;

export const ALL_INDIVIDUAL_PLANS = [
  PLAN_REF_ID_MAPPING.culling,
  PLAN_REF_ID_MAPPING.editing,
  PLAN_REF_ID_MAPPING.retouching,
] as const;

export const PLANS_IN_BUNDLE = [
  PLAN_REF_ID_MAPPING.culling,
  PLAN_REF_ID_MAPPING.editing,
  PLAN_REF_ID_MAPPING.retouching,
] as const;

export const DEFAULT_AVAILABLE_PLANS = [
  PLAN_REF_ID_MAPPING.culling,
  PLAN_REF_ID_MAPPING.editing,
  PLAN_REF_ID_MAPPING.retouching,
];

// Maps add-on IDs to the plan IDs they require (at least one must be in the cart).
// Extend this to add new add-on/plan dependencies.
export const ADD_ON_REQUIRED_PLANS: Partial<Record<string, string[]>> = {
  [ADDON_REF_ID_MAPPING.profiles]: [
    PLAN_REF_ID_MAPPING.editing,
    PLAN_REF_ID_MAPPING.all,
  ],
};
